export const SUPER_ADMIN = 'super-admin';
export const PARTNER_ADMIN = 'partner-admin';
export const getGates = userInfo => {
  var _userInfo$gates;
  return (_userInfo$gates = userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) !== null && _userInfo$gates !== void 0 ? _userInfo$gates : [];
};
export const getUserScopes = userInfo => {
  var _userInfo$user$scopes;
  return (_userInfo$user$scopes = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.scopes) !== null && _userInfo$user$scopes !== void 0 ? _userInfo$user$scopes : [];
};
export const getUserHasSuperAdminScope = userInfo => {
  const scopes = getUserScopes(userInfo);
  return scopes.includes(SUPER_ADMIN) || scopes.includes(PARTNER_ADMIN);
};